var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    stroke: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2695 4.50781C16.355 4.30282 16.645 4.30282 16.7305 4.50781L19.2764 10.627C19.5284 11.2329 20.0978 11.6468 20.752 11.6992L27.3584 12.2295C27.5799 12.2474 27.6696 12.5233 27.501 12.668L22.4678 16.9795C21.9694 17.4064 21.752 18.0765 21.9043 18.7148L23.4414 25.1611C23.493 25.3774 23.2581 25.5485 23.0684 25.4326L17.4121 21.9785C16.8521 21.6365 16.1479 21.6365 15.5879 21.9785L9.93164 25.4326C9.74187 25.5485 9.507 25.3774 9.55859 25.1611L11.0957 18.7148C11.248 18.0765 11.0306 17.4064 10.5322 16.9795L5.49902 12.668C5.33044 12.5233 5.42014 12.2474 5.6416 12.2295L12.248 11.6992C12.9022 11.6468 13.4716 11.2329 13.7236 10.627L16.2695 4.50781Z",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.5ccb6788c248dd5a92257f88a250193b.svg";
export { ForwardRef as ReactComponent };